define('app-Header/main',[],function () {
    return {

        searchMobileContainer: null,

        run: function () {
            /** Navbar component */

            this.searchMobileContainer = $('#searchMobile');
            $module = this;

            if (!$("#searchTabs li").length) {
                $('.group-nav-search_mobile_wrapper').css("display", "none");
            }

            $('.searchMobileButton a').click(function (e) {
                e.preventDefault();
                $module.searchMobileContainer.find('#searchTabs>li.keep').addClass('active');

                $module.searchMobileContainer.find('#searchTabs>li.active').find('.searchContent').show();
                $module.searchMobileContainer.slideToggle('fast');
                $('.travelMenu').addClass('closeMenu');
                $('.searchMobileButton').hide();
                var searchControl = $module.searchMobileContainer.find('#searchControl');
                if ($(searchControl).attr('data-default-search-type') == 'searchMini') {
                    $module.searchMobileContainer.find(".searchSelect").hide();
                    $module.searchMobileContainer.find('#searchTabs>li').addClass('active').find('.searchContent').show();

                }
            });
            $('#editSearchButton').click(function (e) {
                e.preventDefault();
                $module.searchMobileContainer.find('#searchControl').css({ 'display':'block','visibility':'visible'});

                $module.searchMobileContainer.find('#searchTabs>li.keep').addClass('active');

                $module.searchMobileContainer.find('#searchTabs>li.active').find('.searchContent').show();
                $module.searchMobileContainer.slideToggle('fast');
                $('.travelMenu').addClass('closeMenu');
                $('#editSearchButton, #mobile-group-nav').hide();
            });

            $('#filterResults').click(function (e) {
                e.preventDefault();

                $('.leftNav').addClass('popUpFilters').show();
                $('.searchResults, .footer').hide();
                $('.travelMenu').addClass('closeMenu');
                $('#searchSummary, #searchMobile, #mobile-group-nav').hide(); 
                $('#editSearchButton').show();
            });


           

            $('.travelMenu').click(function (e) {
                e.preventDefault();
                if ($(this).hasClass('closeMenu')) {
                    if ($('#mobile-group-nav').is(':visible')) {
                        $('#menuSlide').css('left', '100%');
                        $('#mobile-group-nav').slideToggle('slow');
                        if ($('#searchControl').attr('data-default-search-type') !== "searchMaxiSR") {
                            $('.searchMobileButton').show();
                        }
                        $('.travelMenu').removeClass('closeMenu');
                    }
                    else if ($('.popUpFilters').is(':visible')) {
                        $('.leftNav').removeClass('popUpFilters').hide();
                        $('.searchResults, .footer').show();
                        $('#searchSummary').show();
                        $('.travelMenu').removeClass('closeMenu');
                    }
                    else if ($module.searchMobileContainer.is(':visible')){
                        $module.searchMobileContainer.slideToggle('slow');
                        if ($('#searchControl').attr('data-default-search-type') !== "searchMaxiSR") {
                            $('.searchMobileButton').show();
                        }

                        else if ($('#searchControl').attr('data-default-search-type') == "searchMaxiSR") {
                            $('#editSearchButton, #filterResults').show(); 
                        }
                        $('.travelMenu').removeClass('closeMenu');
                    }
                }
                else {
                    $('#mobile-group-nav').slideToggle('slow'); 
                    $('.searchMobileButton, #searchMobile').hide();
                    $('.travelMenu').addClass('closeMenu');

                }
            });


            $('#mobile-group-nav a.icon').click(function (e) {
                e.preventDefault();
                var currentMenu = $(this).attr('href');
                $('#menuSlide').find('.innerMenuDropdown').hide(); 
                $(currentMenu).show(); 
                $('#menuSlide').css('left','0'); 
            });
            $('a.backToMenu').click(function (e) {
                e.preventDefault();
                $('#menuSlide').css('left', '100%');
            });
            

            // resize tabs for mobile
            $(window).resize(function () {

                if ($(window).width() < 768) {
                    if ($module.searchMobileContainer.is(':visible')) {
                        $('.searchMobileButton').hide();
                        $('.travelMenu').addClass('closeMenu');
                    }
                    else {
                        $("#searchControl").not('.searchResultsBar ').css("display", "block");
                        $module.searchMobileContainer.css("display", "none");
                        $("#searchSummary").show();
                    }
                    
                }
                else {
                    $('.travelMenu').removeClass('closeMenu');
                    $('.searchMobileButton').show();
                    $module.searchMobileContainer.hide();
                }
            });


            //Switch Utility view class
            function utilitySwap() {
                if ($(window).width() < 1199) {
                    $('.utilitySwap').removeClass('utilityLinks').addClass('utilityLinksMobile ');
                    $('.moreOptions').hide();
                    $('.showMoreOptions').removeClass('active');

                }
                else {
                    $('.utilitySwap').removeClass('utilityLinksMobile').addClass('utilityLinks ');
                    $('.moreOptions').show(); 
                }
            }
            utilitySwap();


            function headerScroll() {
                if (!$('body').hasClass('cruise-product')) {
                    
                    if ($(window).width() > 768) {
                        var scrollTop = $(window).scrollTop();
                        var headerHeight = $("#header").outerHeight();
                        var navHeight = $(".meganav").outerHeight();
                        var scrollheight = headerHeight - navHeight;

                        if (scrollTop > (parseFloat(scrollheight))) {
                            if (!$('#header').hasClass('pinned')) {
                                $('#header').css({ 'position': 'fixed', 'top': '-' + scrollheight + 'px' }).addClass('pinned');
                                $('#navSpacer').css({ 'height': headerHeight });
                            }
                        } else {
                            $('#header').css({ 'position': 'relative', 'top': '0px' }).removeClass('pinned');
                            $('#navSpacer').css({ 'height': 0 });
                        }
                        if ($('.leftNav').hasClass('popUpFilters')) {
                            $('.leftNav').removeClass('popUpFilters');
                            $('.searchResults, .footer').show();

                        }
                    }
                    else {
                        // Remove fixed header.
                        $('#header').css({ 'position': 'relative', 'top': '0px' });
                        $('#navSpacer').css({ 'height': 0 });
                    }
                }
            }

            headerScroll();

            function cruiseHeaderScroll() { 
                if ($('body').hasClass('cruise-product')) {
                    var headerHeight = $("#header").outerHeight();
                    $('#navSpacer').css({ 'height': headerHeight + 'px' });
                }
            }
            cruiseHeaderScroll();

            $(window).resize(function () {
                cruiseHeaderScroll();
                utilitySwap();

            });
    
            // Add LOGOUT link when user login through MySaga
            if ($("#divHeaderBar #LogoImage").length) {
                $(".mySagaBackButton").before('<a class="btn btn-primary float-right mt-1 ml-2" href="/api/sitecore/Logout">Logout</a>');
            }

            // Allow the top nav to follow the user down the page.


            $(window).scroll(function () {
                headerScroll();
            });

            $('a.backToMenu').click(function (e) {
                e.preventDefault();
                $('#menuSlide').css('left', '100%');
            });
            $('.showMoreOptions').on('click', function (e) {
                e.preventDefault();
                $(this).toggleClass('active');
                if ($(this).hasClass('active')) {
                    $(this).next('.moreOptions').show();
                }
                else {
                    $(this).next('.moreOptions').hide();
                }
            });
            $('.utilityLinks .contactWidget__phone').mouseover(function () {
                $('.utilityLinks #openingTimes').show();
            });
            $('.utilityLinks .contactWidget__phone').mouseout(function () {
                $('.utilityLinks #openingTimes').hide();
            });

            //Hide close buttons if old nav showing
            if ($('.travelMenuItem').is(':visible')) {
                $('.fallbackClose').hide();
            }

            //If inifinty number is missing populate with original number


            setTimeout(function () {
                var elements = document.getElementsByClassName('InfinityNumber');
                for (var i = elements.length - 1; i >= 0; i--) {
                    var element = elements[i];
                    if (element.innerHTML === '' || element.innerHTML === '&nbsp;') {
                        element.innerHTML = element.getAttribute('data-infinity-number');
                    }
                }
            }, 2000);

            

        }
    }
});
